const visualElementStore = /* @__PURE__ */ new WeakMap();
export {
  visualElementStore
};
